import { Record, List } from 'immutable';

export const MESSAGE_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
};

const defaultValues = {
  messageType: MESSAGE_TYPES.SUCCESS,
  message: '',
};

export default class UserMessage extends Record(defaultValues, UserMessage) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static addMessage(messages, message) {
    return messages.push(message);
  }

  static removeMessage(messages, index) {
    if (!messages.isEmpty()) {
      return messages.delete(index);
    }
    return messages;
  }
}

export const UserMessages = (data) => {
  let userMessages = new List();
  data.forEach((value) => {
    userMessages = userMessages.push(new UserMessage(value));
  });
  return userMessages;
};
